import { SuperIcon } from '@shared/components/SuperIcon/SuperIcon';
import { buildToastStyle, stackStyle, variantMap } from './SuperToast.styles';
import type { SuperToastProps, SuperToastStackProps } from './SuperToast.types';
import { useSuperToastStack } from './useSuperToast';

function SuperToast({ toast, onDismiss }: SuperToastProps) {
  const v = variantMap[toast.variant];
  return (
    <div
      role={toast.variant === 'error' ? 'alert' : 'status'}
      style={buildToastStyle(toast.variant)}
    >
      <span aria-hidden style={{ marginTop: 2 }}>
        <SuperIcon name={v.icon} size="md" color={v.iconColor} />
      </span>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div
          style={{
            fontFamily: 'var(--font-sans)',
            fontSize: 13,
            fontWeight: 500,
            color: 'var(--color-text)',
          }}
        >
          {toast.title}
        </div>
        {toast.description && (
          <div style={{ fontSize: 12, color: 'var(--color-text-dim)', marginTop: 2 }}>
            {toast.description}
          </div>
        )}
        {toast.action && (
          <button
            type="button"
            onClick={toast.action.onClick}
            style={{
              marginTop: 8,
              background: 'transparent',
              border: 'none',
              color: 'var(--color-accent)',
              fontSize: 12,
              fontWeight: 500,
              cursor: 'pointer',
              padding: 0,
            }}
          >
            {toast.action.label}
          </button>
        )}
      </div>
      <button
        type="button"
        aria-label="Dismiss"
        onClick={() => onDismiss(toast.id)}
        style={{
          background: 'transparent',
          border: 'none',
          cursor: 'pointer',
          padding: 4,
          color: 'var(--color-text-mute)',
          display: 'inline-flex',
        }}
      >
        <SuperIcon name="x" size="sm" />
      </button>
    </div>
  );
}

export function SuperToastStack({ className }: SuperToastStackProps) {
  const vm = useSuperToastStack();
  if (vm.toasts.length === 0) return null;
  return (
    <div role="region" aria-label="Notifications" className={className} style={stackStyle}>
      {vm.toasts.map((t) => (
        <SuperToast key={t.id} toast={t} onDismiss={vm.dismiss} />
      ))}
    </div>
  );
}
